export default __webpack_public_path__ + "static/media/logo_index_1.8bbaffae.jpeg";